// React / Next
import { createFileRoute } from '@tanstack/react-router';

// Lib
import { getArticleBySlug } from '../lib/sanity/queries';

// Components
import { ArticleDetailPage } from '../pages/ArticleDetailPage/ArticleDetailPage';

/**
 * Article Detail Route
 * Uses flat route convention (resources_) to not nest under /resources
 * Path: /resources/:slug
 */
export const Route = createFileRoute('/resources_/$slug')({
  loader: async ({ params }) => {
    const article = await getArticleBySlug(params.slug);
    return { article };
  },
  component: ArticleDetailPageWrapper,
});

function ArticleDetailPageWrapper() {
  const { article } = Route.useLoaderData();
  return <ArticleDetailPage article={article} />;
}
